import { render, staticRenderFns } from "./PreventionWrite.vue?vue&type=template&id=50bb6853&scoped=true"
import script from "./PreventionWrite.vue?vue&type=script&lang=js"
export * from "./PreventionWrite.vue?vue&type=script&lang=js"
import style0 from "./PreventionWrite.vue?vue&type=style&index=0&id=50bb6853&prod&scoped=true&lang=css"
import style1 from "./PreventionWrite.vue?vue&type=style&index=1&id=50bb6853&prod&lang=scss&scoped=true"
import style2 from "./PreventionWrite.vue?vue&type=style&index=2&id=50bb6853&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bb6853",
  null
  
)

export default component.exports